import { useFormContext } from 'react-hook-form';
import {
  SCORECARD_COMMON_GOAL_TYPE_CUSAT,
  SCORECARD_GOAL_TYPE_CUSAT,
  SCORECARD_GOAL_TYPE_METRIC,
} from 'constants/scorecards';
import { GoalField } from 'components/GoalsAndSubgoalsForm/interfaces';
import CommonGoalRegularEditor from './CommonGoalRegularEditor.component';
import CommonGoalMetricEditor from './CommonGoalMetricEditor.component';
import CommonGoalCuSatEditor from './CommonGoalCuSatEditor.component';

interface CommonGoalEditorProps {
  goalIndex: number;
  goalsCount: number;
  onRemove?: () => void;
}

export default function CommonGoalEditor({
  goalIndex,
  goalsCount,
  onRemove,
}: CommonGoalEditorProps) {
  const { watch } = useFormContext<GoalField>();
  const type = watch(`goals.${goalIndex}.type`);

  if (type === SCORECARD_GOAL_TYPE_METRIC) {
    return (
      <CommonGoalMetricEditor
        goalIndex={goalIndex}
        goalsCount={goalsCount}
        onRemove={onRemove}
      />
    );
  }
  if (
    type === SCORECARD_GOAL_TYPE_CUSAT ||
    type === SCORECARD_COMMON_GOAL_TYPE_CUSAT
  ) {
    return (
      <CommonGoalCuSatEditor
        goalIndex={goalIndex}
        goalsCount={goalsCount}
        onRemove={onRemove}
      />
    );
  }
  return (
    <CommonGoalRegularEditor
      goalIndex={goalIndex}
      goalsCount={goalsCount}
      onRemove={onRemove}
    />
  );
}
